import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './styles.css';
import { App } from './App';
import { SessionProvider } from './session/SessionContext';
import { recogerMarcaDeAcceso } from './session/regreso';

// Antes de montar nada: la marca de vuelta del acceso se retira de la barra de
// direcciones para que ninguna pantalla la confunda con uno de sus filtros.
recogerMarcaDeAcceso();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root container');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <App />
      </SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
